import React from 'react'
import ReactDOM from 'react-dom'

import 'styles/index.scss'
import App from 'app'
import reportWebVitals from 'reportWebVitals'

// Set GTM when production
if (process.env.NODE_ENV === 'production') {
  require('./utils/googleTagManager')
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
